module.exports = __webpack_public_path__ + "static/media/PC_Data_DESIGN_SPRINT.cdf04410.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/design_sprint/PC_Data_DESIGN_SPRINT.png
// module id = 247
// module chunks = 0